import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import "./ExamNoticesPage.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const ExamNoticesPage = () => {
  const location = useLocation();
  const category = location.state?.category || "notice"; // "notice" or "timetable"

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/exam-notices/public`);
        if (!res.ok) throw new Error("Failed to fetch data");
        const json = await res.json();
        const filteredData = (json.data || []).filter(item => item.category === category);
        setData(filteredData);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [category]);

  const formatDate = (dateStr) => {
    if (!dateStr) return { month: "", day: "" };
    const dateObj = new Date(dateStr);
    if (isNaN(dateObj)) return { month: "", day: "" };
    return {
      month: dateObj.toLocaleString("default", { month: "short" }),
      day: dateObj.getDate(),
    };
  };

  return (
    <div className="exam-page-container">
      <h1 className="title">{category === "notice" ? "Exam Notices" : "Exam Timetables"}</h1>
      <hr />
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && data.length === 0 && <p>No data available.</p>}
      {!loading && !error && data.length > 0 && (
        <div className="exam-list">
          {data.map(item => {
            const { month, day } = formatDate(item.news_date);
            return (
              <div key={item.id} className="news-item">
                <div className="news-date">
                  <span className="month">{month}</span>
                  <span className="day">{day}</span>
                </div>
                <div>
                  <p className="news-content">{item.news_title}</p>
                  {(item.file_path || item.link_url) && (
                    <a
                      className="news-link"
                      href={item.file_path ? `${API_BASE}${item.file_path}` : item.link_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.link_text || 'Click here'}
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExamNoticesPage;
